import React from 'react';
import { SimpleCourseCardSkeleton } from '@crehana/web/dist/components/Cards/SimpleCourseCard';
import { Container, Col, Row } from '@crehana/ui';

import { COMMON_COLS } from './constants';
import { CourseCardSkeleton } from '../CourseCardV3/skeletons';

interface CommonSkeletonProps {
  isPremium: boolean;
  skeletonItems: number;
}

const CommonSkeleton: React.FC<CommonSkeletonProps> = ({
  isPremium,
  skeletonItems,
}) => {
  return (
    <Container full>
      <Row nowrap>
        <Col totalCols={6}>
          <div className="w-full h-24 bg-gray-lighter mb-24" />
        </Col>
        <Col totalCols={6}>
          <div className="w-full h-24 bg-gray-lighter mb-24" />
        </Col>
      </Row>
      <Row>
        {isPremium
          ? Array.from(Array(skeletonItems)).map((_, i) => (
              <Col
                key={i.toString()}
                xs={COMMON_COLS.xs}
                sm={COMMON_COLS.sm}
                md={COMMON_COLS.md}
                lg={COMMON_COLS.lg}
              >
                <SimpleCourseCardSkeleton />
              </Col>
            ))
          : Array.from(Array(skeletonItems)).map((_, i) => (
              <Col
                key={i.toString()}
                xs={COMMON_COLS.xs}
                sm={COMMON_COLS.sm}
                md={COMMON_COLS.md}
                lg={COMMON_COLS.lg}
              >
                <CourseCardSkeleton />
              </Col>
            ))}
      </Row>
    </Container>
  );
};

export default CommonSkeleton;
